/**
 * @deprecated This component is deprecated. Use ChannelLogoPairNew from '../ChannelLogos' instead.
 * This file is kept for backward compatibility but will be removed in a future version.
 */
import { FC, memo } from 'react';
import styled from 'styled-components';
import { ChannelName } from '../../types';

// Import channel SVGs
import AIRBNB from '@assets/svg/airbnb.svg?react';
import GATHERN from '@assets/svg/gathren.svg?react';
import BookingIcon from '@assets/svg/BookingLogo.svg?react';
import MsoolIcon from '@assets/svg/MsoolIcon.svg?react';

interface IChannelLogoPairProps {
  channelName: ChannelName;
  size?: 'small' | 'medium' | 'large';
  showConnector?: boolean;
  isConnected?: boolean;
}

interface ISizeConfig {
  logoSize: number;
  iconSize: number;
  connectorWidth: number;
}

const SIZE_CONFIG: Record<string, ISizeConfig> = {
  small: { logoSize: 40, iconSize: 24, connectorWidth: 20 },
  medium: { logoSize: 56, iconSize: 32, connectorWidth: 32 },
  large: { logoSize: 70, iconSize: 40, connectorWidth: 42 },
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const LogoWrapper = styled.div<{ $size: number; $bgColor: string }>`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  background: ${(props) => props.$bgColor};
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: ${(props) => props.$size * 0.6}px;
    height: ${(props) => props.$size * 0.6}px;
  }
`;

const Connector = styled.div<{ $width: number; $isConnected?: boolean }>`
  width: ${(props) => props.$width}px;
  height: 3px;
  background: ${(props) => (props.$isConnected ? '#12B76A' : '#D0D5DD')};
  position: relative;
  margin: 0 4px;

  ${(props) =>
    props.$isConnected &&
    `
    &::after {
      content: '✓';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 20px;
      height: 20px;
      background: #12B76A;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 10px;
      font-weight: bold;
    }
  `}
`;

const ChannelLogoPair: FC<IChannelLogoPairProps> = memo(({
  channelName,
  size = 'medium',
  showConnector = true,
  isConnected = false,
}) => {
  const config = SIZE_CONFIG[size];

  const getChannelLogo = () => {
    switch (channelName) {
      case 'airbnb':
        return <AIRBNB />;
      case 'booking':
        return <BookingIcon />;
      case 'gathern':
        return <GATHERN />;
      default:
        return null;
    }
  };

  const getChannelBgColor = () => {
    switch (channelName) {
      case 'airbnb':
        return '#FFF5F5';
      case 'booking':
        return '#003B95';
      case 'gathern':
        return '#F9FAFB';
      default:
        return '#F9FAFB';
    }
  };

  return (
    <Container>
      <LogoWrapper $size={config.logoSize} $bgColor="#5B3FFF">
        <MsoolIcon />
      </LogoWrapper>
      {showConnector && (
        <Connector $width={config.connectorWidth} $isConnected={isConnected} />
      )}
      <LogoWrapper $size={config.logoSize} $bgColor={getChannelBgColor()}>
        {getChannelLogo()}
      </LogoWrapper>
    </Container>
  );
});

ChannelLogoPair.displayName = 'ChannelLogoPair';

export default ChannelLogoPair;
